import styled from 'styled-components'
// themes
import { colors } from 'themes/index'

export const Form = styled.form`
  overflow: hidden;
  display: flex;
  height: 100%;
  flex-direction: column;
`

export const ButtonsWrapper = styled.div`
  display: flex;
  gap: 16px;
  padding: 12px;
  background: ${colors.gray200};
`
